import styled from 'styled-components';

export const Wrapper = styled.div<{ isPast?: boolean }>`
  width: 100%;
  position: relative;
  min-height: 60px;
  display: grid;
  margin-top: 0.5rem;
  grid-template-columns: 2fr 1fr 1fr 3fr 1fr 1fr;
  pointer-events: ${({ isPast }) => (isPast ? 'none' : 'auto')};
  cursor: ${({ isPast }) => (isPast ? 'not-allowed' : 'default')};
  opacity: ${({ isPast }) => (isPast ? 0.5 : 1)};

  ${({ theme }) => `
    gap: ${theme.layout.spacing.mikro};
    background: ${theme.colors.neutral.primary[0]};
    border-radius: ${theme.layout.spacing.mikro};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
  `};
`;
